import React from 'react';
import { View } from 'react-native';
import { rem } from 'design-system';
import Amount from 'design-system/Amount';
import { SettingsItem, SettingsItemRightContent, } from 'design-system/SettingsItem';
import useStyles from 'hooks/useStyles';
import createStyleSheets from 'utils/createStyleSheets';
import { isWeb } from '../../../constants';
import CreditReportLenderLogo from './CreditReportLenderLogo';
const CreditReportDebtsList = ({ debts }) => {
    const styles = useStyles(styleSet);
    return (<View style={styles.container}>
      {debts.map((debt) => (<SettingsItem titleProps={{ numberOfLines: 2 }} key={debt.networthAccountId ?? debt.accountId} title={debt.lenderName ?? debt.accountTypeName} renderIcon={() => (<CreditReportLenderLogo inSettingsItem iconUrl={debt.iconUrl} name={debt.lenderName}/>)}>
          {debt.balance !== null ? (<SettingsItemRightContent style={styles.amount}>
              <Amount Numbers-16 showFraction={false} value={{
                    value: Math.abs(debt.balance),
                    currency: debt.currencyCode,
                }}/>
            </SettingsItemRightContent>) : null}
        </SettingsItem>))}
    </View>);
};
const styleSet = createStyleSheets((colors) => ({
    container: {
        marginTop: rem(16),
        borderRadius: rem(16),
        width: '100%',
        paddingVertical: rem(4),
        backgroundColor: colors.background.dark,
        ...(isWeb && {
            paddingHorizontal: rem(8),
        }),
    },
    amount: {
        marginLeft: rem(8),
    },
}));
export default CreditReportDebtsList;
